



















































































import Vue from "vue";
import Component from "vue-class-component";
import { BBadge } from "bootstrap-vue";
import { Prop } from "vue-property-decorator";

import { MyPatientsListItem, VentMode, PatientStatus } from "@/models";
import VaeBadge from "./patient/vae/VaeBadge.vue";
import VentValue from "./patient/vent/VentValue.vue";

@Component({ components: { VaeBadge, BBadge, VentValue } })
export default class MyPatientsRow extends Vue {
  @Prop() readonly patient!: MyPatientsListItem;

  get isInactive() {
    const isVentInactive = this.patient.ventStatus !== PatientStatus.Active;
    const isInfusionInactive = this.patient.infusionStatus !== PatientStatus.Active;

    return isVentInactive && isInfusionInactive;
  }

  get isStandby() {
    return this.patient.ventMode === VentMode.Standby;
  }

  get showVentInfo() {
    return this.patient.ventStatus !== PatientStatus.Hidden;
  }

  get showVentFields() {
    return this.patient.ventStatus === PatientStatus.Active && !this.isStandby;
  }

  get isNonInvasive() {
    return this.patient.isNonInvasive;
  }
}
